import { useState } from "react";
import api from "@api";
import "./StandingSettings.css";

function StandingSettings({ id, pageId, page }) {

 const existingContent = page?.pageSettings?.content || {};

 const [standingsFilters, setStandingsFilters] = useState({
  showLeagueFilter:
   page?.pageSettings?.content?.filters?.showLeagueFilter ?? true,
  showDivisionFilter:
   page?.pageSettings?.content?.filters?.showDivisionFilter ?? true,
 });

 const [visibleHeaders, setVisibleHeaders] = useState({
  position: page?.pageSettings?.content?.visibleHeaders?.position ?? true,
  team: page?.pageSettings?.content?.visibleHeaders?.team ?? true,
  captain: page?.pageSettings?.content?.visibleHeaders?.captain ?? true,
  league: page?.pageSettings?.content?.visibleHeaders?.league ?? true,
  division: page?.pageSettings?.content?.visibleHeaders?.division ?? true,
  wins: page?.pageSettings?.content?.visibleHeaders?.wins ?? true,
  losses: page?.pageSettings?.content?.visibleHeaders?.losses ?? true,
  ftPercentage:
   page?.pageSettings?.content?.visibleHeaders?.ftPercentage ?? true,
  total3PM: page?.pageSettings?.content?.visibleHeaders?.total3PM ?? true,
 });

 const handleSave = async () => {
  try {
   await api.put(`/api/organization-page/${id}/${pageId}`, {
    content: {
     ...existingContent,
     filters: standingsFilters,
     visibleHeaders,
    },
   });

   alert("Settings saved.");
  } catch (err) {
   console.error("Failed to save standings settings:", err);
   alert("Could not save settings.");
  }
 };

 return (
  <div className="standings-settings">
   <div className="standings-settings-card">
    <div className="standings-settings-header">
     <h2 className="standings-settings-title">Standings Settings</h2>
     <p className="standings-settings-subtext">
      Control which standings filters and columns appear publicly.
     </p>
    </div>

    <div className="standings-settings-group">
     <h3 className="standings-settings-group-title">Visible Filters</h3>
     <p className="standings-settings-group-subtext">
      Choose which filters users can use on the public standings page.
     </p>

     <div className="standings-settings-options">
      <label className="standings-settings-option">
       <div>
        <div className="standings-settings-option-title">
         Show League Filter
        </div>
        <div className="standings-settings-option-subtext">
         Allow users to filter standings by league.
        </div>
       </div>
       <input
        type="checkbox"
        checked={standingsFilters.showLeagueFilter}
        onChange={(e) =>
         setStandingsFilters((prev) => ({
          ...prev,
          showLeagueFilter: e.target.checked,
         }))
        }
       />
      </label>

      <label className="standings-settings-option">
       <div>
        <div className="standings-settings-option-title">
         Show Division Filter
        </div>
        <div className="standings-settings-option-subtext">
         Allow users to filter standings by division or bracket.
        </div>
       </div>
       <input
        type="checkbox"
        checked={standingsFilters.showDivisionFilter}
        onChange={(e) =>
         setStandingsFilters((prev) => ({
          ...prev,
          showDivisionFilter: e.target.checked,
         }))
        }
       />
      </label>
     </div>
    </div>

    <div className="standings-settings-group">
     <h3 className="standings-settings-group-title">Visible Table Columns</h3>
     <p className="standings-settings-group-subtext">
      Choose which columns appear in the public standings table.
     </p>

     <div className="standings-settings-grid">
      {[
       { key: "position", title: "Position" },
       { key: "team", title: "Team" },
       { key: "captain", title: "Captain" },
       { key: "league", title: "League" },
       { key: "division", title: "Division" },
       { key: "wins", title: "Wins" },
       { key: "losses", title: "Losses" },
       { key: "ftPercentage", title: "FT%" },
       { key: "total3PM", title: "3PM" },
      ].map((item) => (
       <label
        key={item.key}
        className="standings-settings-stat-card"
       >
        <div>
         <div className="standings-settings-option-title">
          {item.title}
         </div>
         <div className="standings-settings-option-subtext">
          Show {item.title.toLowerCase()} column
         </div>
        </div>

        <input
         type="checkbox"
         checked={visibleHeaders[item.key]}
         onChange={(e) =>
          setVisibleHeaders((prev) => ({
           ...prev,
           [item.key]: e.target.checked,
          }))
         }
        />
       </label>
      ))}
     </div>
    </div>

    <div className="standings-settings-actions">
     <button
      type="button"
      className="standings-settings-save-btn"
      onClick={handleSave}
     >
      Save Settings
     </button>
    </div>
   </div>
  </div>
 );
}

export default StandingSettings;